import styled from 'styled-components';

export const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
`;

export const PreTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
  margin-bottom: 24px;
`;

export const Title = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
`;

export const Text = styled.div`
  margin-top: 12px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);

  b {
    color: #EC5E59;
  }

  strong {
    font-weight: 700;
    color: rgba(0, 27, 59, 1);
  }

  a:active, a:visited, a:link {
    color: #97b8f6;
    text-decoration: underline;
  }

  a:hover {
    text-decoration: none;
  }

  ul {
    list-style-type: disc;
    margin-left: 20px;
    margin-top: 10px;
  }

  ul li {
    font-size: 16px !important;
  }

  p {
    margin-bottom: 8px;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

export const ContentContainer = styled.div`
  margin-top: 12px;
`;

// charts components
export const Charts = {
  Wrapper: styled.div`
    background: #fff;
    width: 100%;
    position: relative;
    z-index: 1;
    padding: 0 5px;

    ${p =>
      p.setMaxHeight &&
      `
      max-height: 450px;
    `}
  `,
  Teams: {
    Wrapper: styled.div`
      display: flex;
      padding: 24px 15px 20px;
      color: #36507e;
      font-weight: 600;
      font-size: 15px;
    `,
    Row: styled.div`
      display: flex;
      justify-content: flex-start;
      align-items: center;

      ${p =>
        p.margin &&
        `
        margin: ${p.margin};
      `}
    `,
    TeamColor: styled.div`
      height: 10px;
      width: 40px;
      margin-right: 10px;

      ${p =>
        p.background &&
        `
        background: ${p.background};
      `}
    `,
    TeamName: styled.div`
      font-size: 14px;
      color: #36507e;
    `
  },
  Chart: styled.div`
    width: 100%;
  `
};

export const ContentContainerWithBackground = styled.div`
  margin-top: 12px;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #D5D9DD;
  font-family: 'Mukta Vaani';
  font-style: normal;
`;


// WEBPACK FOOTER //
// ./src/components/peer-feedback/components/ui.js